<h3>Album photo</h3>
<form #uploadForm="ngForm" (ngSubmit)="postPhoto()">
  <input
    type="file"
    name="fileUpload"
    id="fileUpload"
    (change)="onFileChange($event)"
    required
  /><br />
  <input
    type="text"
    name="title"
    id="title"
    [(ngModel)]="photo.title"
    placeholder="titre de la photo"
    required
  />
  <button type="submit" [disabled]="!uploadForm.form.valid">uploader</button>
</form>

<div>
  <img [src]="uploadedImgURL" alt="" style="width: 150px" />
</div>
